<template>
  <div :class="{center_loading: center}">
    <img src="../../assets/img/loading.svg" width="120" height="120">
  </div>
</template>
<script>
export default {
  name: "Loading",
  props: {
    center: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style scoped>
.center_loading{
  text-align: center;
}
</style>
